import { IRequestOptions, IResponseResult } from 'models/api.model'
import { RequestMethod } from 'root-constants'
import { ApiService } from 'services/api.service'

export class CalendlyApi {
  private api: ApiService

  constructor(api: ApiService) {
    this.api = api
  }

  getCalendly(url: string): Promise<IResponseResult<Response>> {
    const options: IRequestOptions = {
      method: RequestMethod.GET,
      credentials: 'same-origin',
    }

    return this.api.makeCustomRequestWithoutScheme<IResponseResult<Response>>(
      url,
      options,
    )
  }

  postCalendly(url: string): Promise<IResponseResult<Response>> {
    const options: IRequestOptions = {
      method: RequestMethod.POST,
      credentials: 'same-origin',
      keepalive: true,
    }

    return this.api.makeCustomRequestWithoutScheme<IResponseResult<Response>>(
      url,
      options,
    )
  }
}
